
import { DxScrollView } from "devextreme-vue";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    DxScrollView,
  },
  props: {
    model: {} as any,
  },
  methods: {
    numberFormat(value: number, digits?: number) {
      return Intl.NumberFormat("ru-RU", {maximumFractionDigits: digits}).format(value);
    },
  },
});
